import { Stack } from '@mui/material';
import {
  IWsChatBubbleProps,
  WsChatBubble,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

export interface ISmsLogsChatBubble {
  message: string;
  recruiterName: string;
  candidateName: string;
  creditConsumed: number;
  messageStatus: string;
  onClick: () => void;
}

const SmsLogsChatBubble = ({
  direction,
  message,
  recruiterName,
  candidateName,
  creditConsumed,
  messageStatus,
  onClick,
}: IWsChatBubbleProps & ISmsLogsChatBubble) => {
  return (
    <WsChatBubble sx={{ minWidth: 500 }} direction={direction}>
      <WsTypography variant={WsTypoVariants.TITLE}>{message}</WsTypography>
      <Stack alignItems={'flex-end'}>
        <WsTypography>{direction === 'OUTBOUND' ? candidateName : recruiterName}</WsTypography>
        {direction === 'OUTBOUND' && (
          <WsTypography>{`Credits consumed: ${creditConsumed}`}</WsTypography>
        )}
        <WsTypography>{messageStatus}</WsTypography>
        <WsTypography onClick={onClick} color={WsTypoColors.PRIMARY} cursor={'pointer'}>
          View details
        </WsTypography>
      </Stack>
    </WsChatBubble>
  );
};

export default SmsLogsChatBubble;
